import { combineReducers } from "@reduxjs/toolkit";
import remote from "./remote/remoteSlice";
import user from "./user/UserSlice";
import appSettings from "./appSettings/appSettingsSlice";

export default combineReducers({
    remote,
    user,
    appSettings
});